import React, { useState, useContext, useEffect } from "react";
import "./filter.css";
import Dropdown from "react-bootstrap/Dropdown";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { BiGrid } from "react-icons/bi";
import { NavLink } from "react-router-dom";
import { BiSearch } from "react-icons/bi";
import Accordion from "react-bootstrap/Accordion";
import { FaAngleDown } from "react-icons/fa";
import Form from "react-bootstrap/Form";
import { AiFillStar } from "react-icons/ai";
import SearchContext from "../../context/SearchContext";
import FilterRating from "../filterRating/FilterRating";
import { baseUrl } from "../../context/BaseUrl";

const Filter = ({ category_id}) => {
  const { search, setSearch } = useContext(SearchContext);
  const [result, setResult] = useState(false);
  const [data, setData] = useState(false);
  const [citydata, setCitydata] = useState(false);
  const [show, setShow] = useState(false);
  const [subject, setSubject] = useState([]);
  const [rate, setRate] = useState(0);
  const [price, setPrice] = useState("");
  const handlerange = (e) => {
    setPrice(e.target.value);
      setSearch({ ...search,     budget_max: e.target.value })
  };

  const loadExam = async () => {
    const dataExam = await fetch(
      `${baseUrl}/user/category/getcategory_details/${category_id}`
    );
    const subject = await dataExam.json();

    setResult(subject);
  };

  useEffect(() => {
    loadExam();
  }, []);

  const handlestate = (e) => {
    const value = e.target.value;
    const state_obj = data[0].states.filter((val, i)=> val.state_id == value );
    const CityApi = async () => {

      const response = await fetch(`https://cdn-api.co-vin.in/api/v2/admin/location/districts/${state_obj[0].state_id}`, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      if (result.error) {
        console.warn("got an error in response", result.error);
        return;
      }
        setCitydata([result]);
    };
    CityApi();
  };

  const ApiPost = async () => {

    const response = await fetch(`https://cdn-api.co-vin.in/api/v2/admin/location/states`, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();
    if (result.error) {
      console.warn("got an error in response", result.error);
      return;
    }
      setData([result]);
  };
  
  useEffect(() => {
  ApiPost();
}, []);
useEffect(() => {
  setSearch({...search, 
    rating: rate,
    budget_max: price,
    sort: "namea",
 })
}, [citydata, rate]);
 
const handleCourse = (e) => {
  const subName = e.target.id;
  const sub = e.target.checked;

  if (sub){
    subject.push(subName)
  }
  if(!sub){
    const remove = subject.findIndex((item) => item == subName);
    subject.splice(remove, 1)
  }
  setSearch({ ...search, subject: subject })
}

  return (
    <React.Fragment>
      <div className="d-flex PC-filter flex-column flex-sm-row">
        <div className="left">
          <button className="filt-btn" onClick={() => setShow(!show)}>
            {" "}
            Filters <FaAngleDown />{" "}
          </button>
          {show && result && (
            <div className="filt-content">
              <h5>Filters</h5>
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Subject</Accordion.Header>
                  <Accordion.Body>
                    <Form>
                      {result.subjects.map((el, loop) => (
                        <div key={loop}>
                          <Form.Check
                            className="mb-3"
                            label={`${el}`}
                            name={`subject`}
                            type={"checkbox"}
                            id={`${el}`}
                            onClick={handleCourse}
                            
                          />
                        </div>
                      ))}
                    </Form>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header id="city">Location</Accordion.Header>
                  <Accordion.Body className='py-2 px-3'>
                  <div className="mb-1 row">
                    <div className="col-md-6 col-sm-6">
                        <label htmlFor="State" className="col-form-label">State</label>
                        <Form.Select className='' onChange={handlestate} >
                        <option value=''>Select Institute......</option>
                        {data ? data[0].states.map((item, index)=> <option key={index} value={item.state_id}> {item.state_name} </option>) : <option> 1 </option> }
                      </Form.Select>
                      </div>
                      <div className="col-md-6 col-sm-6">
                        <label htmlFor="City" className="col-form-label">City</label>
                        <Form.Select className='' onChange={(e) => setSearch({ ...search, location: [e.target.value] })} name="city">
                        <option value=''>Select Institute......</option>
                        {citydata ? citydata[0].districts.map((item, index)=> <option key={index} value={item.district_name}> {item.district_name} </option>) : <option value=''>Please select state first</option> }
                      </Form.Select>
                      </div>
                    </div>
                    {/* <Form>
                      {["checkbox"].map((type) => (
                        <div key={`reverse-${type}`}>
                          <Form.Check
                            className="mb-3"
                            reverse
                            label="Delhi"
                            name="group1"
                            type={type}
                            id={`reverse-${type}-1`}
                          />
                          <Form.Check
                            className="mb-3"
                            reverse
                            label="Mumbai"
                            name="group1"
                            type={type}
                            id={`reverse-${type}-2`}
                          />
                          <Form.Check
                            className="mb-3"
                            reverse
                            label="Kolkata"
                            name="group1"
                            type={type}
                            id={`reverse-${type}-3`}
                          />
                          <Form.Check
                            className="mb-3"
                            reverse
                            label="Banglore"
                            name="group1"
                            type={type}
                            id={`reverse-${type}-4`}
                          />
                          <Form.Check
                            className="mb-3"
                            reverse
                            label="Pune"
                            name="group1"
                            type={type}
                            id={`reverse-${type}-4`}
                          />
                        </div>
                      ))}
                    </Form> */}
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>Ratings</Accordion.Header>
                  <Accordion.Body>
                    <div className="rating">
                      <FilterRating handle={{ rate, setRate }} />
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>Budget</Accordion.Header>
                  <Accordion.Body>
                    <div className="range d-flex align-items-center gap-1">
                      ₹50000
                      <input
                        type="range"
                        style={{ width: "150px" }}
                        min="50000"
                        max="200000"
                        step="5000"
                        value={price}
                        onInput={handlerange}
                      />
                      <output>{`₹ ${price}`}</output>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>Mode of Course</Accordion.Header>
                  <Accordion.Body>
                    <Form.Select
                      className="form-control"
                      onChange={(e) =>
                        setSearch({ ...search, available: e.target.value })
                      }
                    >
                      <option value={"online"}>Online</option>
                      <option value={"offline"}>Offline</option>
                      <option value={"both"}>Both</option>
                    </Form.Select>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          )}

          <div className="search">
            <input
              placeholder="search.."
              className="w-100"
              type="text"
              onInput={(e) => setSearch({ ...search, name: e.target.value })}
            />
            <span>
              <BiSearch />
            </span>
          </div>
        </div>

        <div className="right mt-4">
          <Dropdown className="d-lg-inline-block d-none dropdown me-0 me-5 me-sm-5 nav-link-lg text-decoration-none">
            <span className="text-nowrap"> Sort by </span>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => setSearch({ ...search, sort: e.target.value })}
            >
              <option className="">Select---</option>
              <option value="namea">Name (A - Z)</option>
              <option value="named">Name (Z - A)</option>
              <option value="pricea">Budget (Low {">"} High)</option>
              <option value="priced">Budget (High {">"} Low)</option>
              <option value="ratinga">Rating (Low {">"} High)</option>
              <option value="ratingd">Rating (High {">"} Low)</option>
              <option value="latest">Latest</option>
              <option value="oldest">Oldest</option>
            </Form.Select>
          </Dropdown>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Filter;
